import { Construction } from "lucide-react";

export default function ComingSoon({ title, description, bullets = [] }) {
  return (
    <div data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <header className="mb-10">
        <p className="ed-overline mb-3">Studio</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-[var(--ed-ink)]">{title}</h1>
        {description && (
          <p className="text-[var(--ed-ink-soft)] text-sm mt-2 max-w-xl leading-relaxed">{description}</p>
        )}
      </header>

      <div className="border border-[var(--ed-rule)] bg-[var(--ed-paper)]/40 rounded-sm">
        <div className="px-8 py-12 lg:py-16 flex flex-col lg:flex-row gap-10 items-start">
          <div className="flex-shrink-0 w-16 h-16 rounded-full bg-[var(--ed-emerald-tint)] text-[var(--ed-emerald)] flex items-center justify-center">
            <Construction size={26} strokeWidth={1.4} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="ed-overline mb-3 text-[var(--ed-emerald)]">In studio · arriving soon</p>
            <h2 className="font-serif text-2xl sm:text-3xl text-[var(--ed-ink)] mb-4 leading-tight">
              We&rsquo;re finishing this with the same care as everything else.
            </h2>
            <p className="text-[var(--ed-ink-soft)] text-[15px] leading-relaxed mb-7 max-w-2xl">
              This module is part of the next chapter of the West London Stays studio.
              Existing features &mdash; bookings, payments, emails &mdash; continue to work
              without interruption while we shape this page into something worth using.
            </p>
            {bullets.length > 0 && (
              <ul className="space-y-2.5 max-w-xl">
                {bullets.map((b) => (
                  <li key={b} className="flex items-start gap-3 text-[var(--ed-ink-soft)] text-sm">
                    <span className="mt-2 w-1 h-1 rounded-full bg-[var(--ed-emerald)] flex-shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
